export default function tenantWiseLogic({
  history,
  auth,
  location,
  folderPath,
  renderComponent
}) {
  return {
    authCheck: ({ config }) => {
      return (
        !history.location.pathname.includes('/manager/login') &&
        !history.location.pathname.includes('/auth/login') &&
        !history.location.search.includes('token')
      );
    },
    roleCheck: ({ config, renderComponent }) => {
      return true;
    },
    adminSuspended: ({ config, renderComponent }) => {
      return true;
    },
    hasSubscription: ({ config, renderComponent }) => {
      return true;
    }
  };
}
